var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
      opId: '20005',
      name: '业务逻辑',
      parentId: 'FILECLASS_ID',
      parentName: '文件类型定义',
      parentPath: '/system/fileclass',
      dataClass: 2,
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }